<template>
    <div class="vc-header vc-style-aui-anchors">
        <div class="vc-header-main-row">
            <div class="vc-header-left">
                <TheHeaderLogo class="vc-header-divider" :marketscope="marketscope" :site="site" />
                <AccountSwitcherLoader class="vc-header-account-switcher vc-header-divider" />
            </div>
            <TheHeaderRight />
        </div>
        <TheNavigation />
    </div>
</template>

<script>
import { mapState } from 'pinia';
import { useContextStore } from '../stores/contextStore';
import AccountSwitcherLoader from './AccountSwitcherLoader.vue';
import TheHeaderLogo from './TheHeaderLogo.vue';
import TheHeaderRight from './TheHeaderRight.vue';
import TheNavigation from './TheNavigation.vue';

export default {
    name: 'TheHeader',
    components: {
        AccountSwitcherLoader,
        TheNavigation,
        TheHeaderLogo,
        TheHeaderRight,
    },
    computed: {
        ...mapState(useContextStore, ['site', 'marketscope']),
    },
};
</script>

<style lang="scss" scoped>
.vc-header {
    font-family: $font-family-base;
    margin-bottom: 30px;

    &-main-row {
        align-items: center;
        display: flex;
        height: 48px;
        justify-content: space-between;
        padding: 0 24px;
    }

    &-left {
        align-items: center;
        display: flex;
    }

    &-account-switcher {
        margin-left: 16px;
    }

    &-divider {
        border-left: 1px solid #ddd;
        padding: 0 16px;

        &:first-child {
            border-left: unset;
            padding-left: 0;
        }
    }
}
</style>
